import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Loader2, Lock, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin/dashboard", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-zinc-500 hover:text-white mb-8 text-sm">
          <ArrowLeft className="w-4 h-4" /> Zur Website
        </Link>
        <div className="card-dark p-8 sm:p-10">
          <div className="w-14 h-14 rounded-2xl bg-red-600/15 flex items-center justify-center mb-6">
            <Lock className="w-7 h-7 text-red-500" />
          </div>
          <h1 className="text-2xl font-bold text-white mb-1">Admin-Portal</h1>
          <p className="text-zinc-500 text-sm mb-7">Bitte melden Sie sich an, um fortzufahren.</p>

          <form onSubmit={submit} data-testid="login-form" className="space-y-4">
            <input data-testid="login-email" type="email" className="input-dark" placeholder="E-Mail" value={email} onChange={(e) => setEmail(e.target.value)} />
            <input data-testid="login-password" type="password" className="input-dark" placeholder="Passwort" value={password} onChange={(e) => setPassword(e.target.value)} />
            {error && <p data-testid="login-error" className="text-red-500 text-sm">{error}</p>}
            <button data-testid="login-submit" type="submit" disabled={loading} className="btn-primary w-full">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Anmelden"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
